<template>
	<div class="gb-photoalbum-select-list" v-bind:style="styleScheduleList">
		<div class="list-content" v-if="items">
			<GBPhotoAlbumSelectListRow
				v-for="item in showList"
				v-bind:key="item.id"
				v-bind:item="item"
				v-bind:select_id="select_id"
				v-on:select-list="onSelectList"
			/>
		</div>
	</div>
</template>
<script>
import GBPhotoAlbumSelectListRow from './GBPhotoAlbumSelectListRow';
import Util from '../../classes/Util';

const HEADER_HEIGHT = 30;
const HEADER_ALBUM_HEIGHT = 59;

export default {
	name: 'GBPhotoAlbumSelectList',
	props: [
		"items",
		"filter_text",
		"select_id",
	],
	components: {
		GBPhotoAlbumSelectListRow,
	},
	methods: {
		onSelectList: function(e) {
			this.$emit('select-list', e);
		},
	},
	computed: {
		styleScheduleList: function() {
			return {
				'height': (this.$store.getters.height - HEADER_HEIGHT - HEADER_ALBUM_HEIGHT) + 'px',
			}
		},
		showList: function() {
			return this.items.filter((item) => {
				if (this.filter_text === null || this.filter_text === undefined)
					return true;
				if (this.filter_text.length === 0)
					return true;
				return item.name.search(Util.replaceEscapeString(this.filter_text)) >= 0;
			});
		},
	},
}
</script>
<style>
	.gb-photoalbum-select-list {
		flex: 0 0 299px !important;
		z-index: 101;
		border-right: 1px solid #dfdfdf;
		overflow-y: hidden;
		overflow-x: hidden;
		background-color: white;
		user-select: none;
	}
	.gb-photoalbum-select-list .list-content {
		overflow-y: scroll;
		overflow-x: hidden;
		width: 100%;
		height: 100%;
		-webkit-overflow-scrolling: touch;
		overscroll-behavior-y: contain;
	}
</style>
